import React from "react";

const WhyChoose = () => {
  return (
    <div>
      <div className="container-fluid bg-image">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 my-3">
              <div className="col-lg-12 wow fadeInUp" data-wow-delay="0.3s">
                <h6 className="section-title bg-white text-start text-primary pe-3">
                  Why Choose Us
                </h6>
                <h2 className="mb-4"> Why You Should Start Learning with Us?</h2>
              </div>
              <p className="mb-4 pb-2">
                Whether you're starting your IT journey or advancing your
                technical skills, our training programs are designed to meet the
                diverse needs of learners. Join us to gain cutting-edge
                knowledge, hands-on experience, and industry-recognized
                certifications.
              </p>
              <div className="d-flex mb-4">
                <div className="btn-icon bg-primary mr-4">
                  <i className="fa fa-2x fa-graduation-cap text-white"></i>
                </div>
                <div className="mt-n1">
                  <h4>Expert Instructors</h4>
                  <p>
                    Learn from industry leaders and certified professionals with
                    years of experience.
                  </p>
                </div>
              </div>
              <div className="d-flex mb-3">
                <div className="btn-icon bg-secondary mr-4">
                  <i className="fa fa-2x fa-certificate text-white"></i>
                </div>
                <div className="mt-n1">
                  <h4>Comprehensive Curriculum</h4>
                  <p>
                    Stay ahead with courses designed to meet current market
                    demands.
                  </p>
                </div>
              </div>
              <div className="d-flex">
                <div className="btn-icon bg-warning mr-4">
                  <i className="fa fa-2x fa-book text-white"></i>
                </div>
                <div className="mt-n1">
                  <h4>Flexible Learning Options</h4>
                  <p className="m-0">
                    We understand that every learner has unique needs and
                    commitments. That’s why we offer flexible learning options
                    to ensure you can pursue your education seamlessly while
                    balancing other responsibilities which includes:{" "}
                  </p>
                  <div className="mt-2">
                    <ul>
                      <li>
                        <p>In-person Training</p>
                      </li>
                      <li>
                        <p>online Training</p>
                      </li>
                      <li>
                        <p>Hybrid Learning</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-5 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ minHeight: "200px" }}
            >
              <div className="position-relative h-100">
                <img
                  className="img-fluid position-absolute w-100 h-100"
                  src="img/welcome_to_diksha_2.png"
                  alt=""
                  style={{ objectFit: "contain" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;
